import { Box, Grid } from '@mui/material';
import React, { useContext } from 'react';
import { MarginBottom8 } from 'spw-shared/globalComponents/containers';
import {
  AlignCenterColumn,
  AlignCenterRow,
  SpaceBetweenAlignCenterColumn,
  SpaceBetweenRow,
  JustifyCenterColumn,
} from 'spw-shared/globalComponents/grid';
import { asPercentage, numberWithCommasOrDash } from 'spw-shared/utils';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import {
  CardTitle,
  BigValuePair,
  BigValue,
  BigKey,
  BaseValue,
  Operator,
  BaseLabel,
  Highlighted,
  IconWrapper,
} from './styles';
import { PlainProgramScenario } from '../../../../models/Scenario';
import { ProgrammingSummaryCardsContext } from '../program-summary-tabs/summary-card-context';

export const HeadcountAnalysis = ({
  scenario,
  testingPrefix,
}: {
  testingPrefix: string;
  scenario: PlainProgramScenario;
}) => {
  const cardIcon = useCardIcon(ProgramSummaryCardType.headcountAnalysis);
  const { selectedCardIcon, onClickCardIcon } = useContext(
    ProgrammingSummaryCardsContext
  );

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType === ProgramSummaryCardType.headcountAnalysis;

  return (
    <Box>
      <CardTitle data-testid={`${testingPrefix}_title`}>
        HEADCOUNT ANALYSIS
      </CardTitle>
      <Grid container>
        <Grid item xs={6}>
          <JustifyCenterColumn>
            <SpaceBetweenRow>
              <SpaceBetweenAlignCenterColumn>
                <MarginBottom8>
                  <AlignCenterRow>
                    <BaseValue data-testid={`${testingPrefix}_headcount`}>
                      {numberWithCommasOrDash(scenario.headcount)}
                    </BaseValue>
                    <BaseLabel data-testid={`${testingPrefix}_headcount_label`}>
                      Headcount
                    </BaseLabel>
                  </AlignCenterRow>
                </MarginBottom8>
                <MarginBottom8>
                  <Operator>x</Operator>
                </MarginBottom8>
                <MarginBottom8>
                  <Highlighted>
                    <BaseValue
                      data-testid={`${testingPrefix}_headcountUtilization`}
                    >
                      {asPercentage(
                        scenario.headcountUtilizationPercentage / 100,
                        0
                      )}
                    </BaseValue>
                    <BaseLabel
                      data-testid={`${testingPrefix}_headcountUtilization_label`}
                    >
                      Headcount Utilization
                    </BaseLabel>
                  </Highlighted>
                </MarginBottom8>
              </SpaceBetweenAlignCenterColumn>
              <JustifyCenterColumn>
                <MarginBottom8>
                  <Operator>=</Operator>
                </MarginBottom8>
              </JustifyCenterColumn>
            </SpaceBetweenRow>
          </JustifyCenterColumn>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <AlignCenterColumn>
            <AlignCenterRow>
              <IconWrapper>
                <CardIcon
                  iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                  onClick={handleIconClick}
                  height={40}
                  isSelected={isIconCardSelected}
                />
              </IconWrapper>
              <BigValuePair className="no-padding">
                <BigValue
                  data-testid={`${testingPrefix}_headcountWithUtilization`}
                >
                  {numberWithCommasOrDash(scenario.headcountWithUtilization)}
                </BigValue>
                <BigKey
                  data-testid={`${testingPrefix}_headcountWithUtilization_label`}
                >
                  Headcount
                </BigKey>
              </BigValuePair>
            </AlignCenterRow>
          </AlignCenterColumn>
        </Grid>
      </Grid>
    </Box>
  );
};
